import React from 'react';
import CheckableTag from "antd/es/tag/CheckableTag";
import { AppstoreOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";
import { queryParams } from "../../helpers/UrlHelpers";

import './style.scss';

interface ListViewButtonsInterface {
  className?: string;
  align?: 'left' | 'right';
  defaultType?: 'grid' | 'list';
}

const ListViewButtons = ({ className, defaultType, align = 'left' }: ListViewButtonsInterface) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const listType: any                   = queryParams.get(searchParams,'view');

  let extraClass: string = `${className || ''}`;
  extraClass += align === 'right' ? ' v-list-view-buttons--right' : '';
  extraClass += align === 'left' ? ' v-list-view-buttons--left' : '';

  function setListType(type: 'grid' | 'list') {
    searchParams.set('view', type);
    setSearchParams(searchParams, { replace: true });
  }

  return (
    <div className={`v-list-view-buttons ${extraClass}`}>
      <CheckableTag
        checked={listType === 'grid' || (!listType && defaultType === 'grid')}
        onChange={() => setListType('grid')}
      >
        <AppstoreOutlined />
      </CheckableTag>

      <CheckableTag
        checked={listType === 'list' || (!listType && defaultType === 'list')}
        onChange={() => setListType('list')}
      >
        <UnorderedListOutlined />
      </CheckableTag>
    </div>
  );
}

export default ListViewButtons;
